import { NavItem } from './nav-item';

export class SettingsNavItem extends NavItem {}
